module.exports = __webpack_public_path__ + "img/edmbet-support.601c8986.png";